var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('image',{attrs:{"xlink:href":require("../../assets/conditions/planet-type.svg"),"width":"20","height":"20","x":"-10","y":"-10"}})])}
var staticRenderFns = []

export { render, staticRenderFns }